import { price as priceUtils, constants } from '@eti/utils';
import { Inline, Stack, Text, Button, LinkButton, textVariants } from '@etg/wings';
import { ReactComponent as SeatIcon } from '@eti/assets/icons/Seat_thin.svg';
import { Trash, Pen } from '@phosphor-icons/react';
import { cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { useTravelerButton } from '../hooks/useTravelerButton';
import { travelerButtonMobile, activeBorder, inactiveBorder, mobiletravelerdetails, blackText, listItem, nonInteractiveTextStyles } from '../utils/styles';
import FadeMotion from './FadeMotion';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const SeatMapTravelerList = _ref => {
  let {
    activeSeatAssignments,
    activeTraveler,
    id,
    isRyanairInTrip,
    name,
    onChange,
    onRemoveSeat,
    setTravelerButtonWithRemoveLink,
    travelerButtonWithRemoveLink
  } = _ref;
  const {
    t
  } = useTranslation();
  const selectedSeat = activeSeatAssignments.find(s => String(s.id) === String(id));
  const showRemove = travelerButtonWithRemoveLink === id;
  const {
    handleClick,
    handleFocus,
    isActive
  } = useTravelerButton({
    activeTraveler,
    onChange,
    selectedSeat,
    setTravelerButtonWithRemoveLink,
    travelerId: id
  });
  const renderSeatInfo = () => {
    if (!selectedSeat) {
      return /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: "select",
        children: /*#__PURE__*/_jsx(Text, {
          "aria-label": t('ScreenReader.Seatmap.Seat.Not.Selected.Text'),
          className: mobiletravelerdetails,
          variant: textVariants._14_BOLD,
          children: t('Seating.SelectSeat.Header.Text')
        })
      });
    }
    return /*#__PURE__*/_jsxs(Inline, {
      noWrap: true,
      spacing: 8,
      children: [!isRyanairInTrip && /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: `price-${selectedSeat.price}`,
        children: /*#__PURE__*/_jsx(Text, {
          className: blackText,
          children: priceUtils.formatPrice(selectedSeat.price)
        })
      }), /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: `seat-${selectedSeat.value}`,
        children: /*#__PURE__*/_jsx(Text, {
          className: blackText,
          children: selectedSeat.value
        })
      }), showRemove ? /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: "remove",
        children: /*#__PURE__*/_jsx(LinkButton, {
          "data-testid": "remove-icon",
          onClick: e => {
            e.stopPropagation();
            onRemoveSeat();
            setTravelerButtonWithRemoveLink(undefined);
          },
          children: /*#__PURE__*/_jsx(Trash, {
            alt: t('Product.SeatMap.Summary.Seat.Remove'),
            size: 20
          })
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: nonInteractiveTextStyles,
        children: /*#__PURE__*/_jsx(FadeMotion, {
          motionKey: "edit",
          children: /*#__PURE__*/_jsx(LinkButton, {
            "data-testid": "edit-icon",
            children: /*#__PURE__*/_jsx(Pen, {
              alt: t('Product.SeatMap.Change.Label'),
              size: 20
            })
          })
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx("li", {
    className: listItem,
    "data-testid": `seatMapTraveler-${id}`,
    children: /*#__PURE__*/_jsx(Button, {
      "aria-current": isActive ? 'step' : undefined,
      className: cx(travelerButtonMobile, isActive ? cx(activeBorder) : inactiveBorder),
      "data-testid": `seatMapTravelerListButton-${id}`,
      id: `seatMapTravelerListButton-${id}`,
      onClick: handleClick,
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsxs(Inline, {
        noWrap: true,
        spacing: 4,
        children: [/*#__PURE__*/_jsx(SeatIcon, {}), /*#__PURE__*/_jsxs(Stack, {
          align: "start",
          spacing: 8,
          children: [/*#__PURE__*/_jsx(FadeMotion, {
            motionKey: `traveler-${id}`,
            children: /*#__PURE__*/_jsx(Text, {
              className: cx(mobiletravelerdetails, 'seatMap__travelerName', MOUSE_FLOW_CLASS_NAMES, blackText),
              variant: textVariants._14_BOLD,
              children: name
            })
          }), renderSeatInfo()]
        })]
      })
    })
  });
};
export default SeatMapTravelerList;
//# sourceMappingURL=SeatMapTravelerList.js.map